export type CerbosFeature =
  | 'feature:viewer:toolbar:focus'
  | 'feature:viewer:toolbar:comment'
  | 'feature:viewer:toolbar:select'
  | 'feature:viewer:toolbar:translate'
  | 'feature:viewer:toolbar:rotate'
  | 'feature:viewer:toolbar:scale'
  | 'feature:viewer:toolbar:light'
  | 'feature:viewer:toolbar:volume_calculation'
  | 'feature:viewer:toolbar:measurement'
  | 'feature:viewer:toolbar:measurement:advanced'
  | 'feature:viewer:toolbar:design'
  | 'feature:viewer:toolbar:tiled_model_scene'
  | 'feature:viewer:toolbar:ortho_tile_scene'
  | 'feature:viewer:toolbar:point_cloud_scene'
  | 'feature:viewer:toolbar:profile_section'
  | 'feature:viewer:toolbar:compare_ortho_photos'
  | 'feature:viewer:toolbar:original_photos'
  | 'feature:viewer:toolbar:occlusion_culling'
  | 'feature:viewer:toolbar:reference_plane'
  | 'feature:viewer:toolbar:intersection'
  | 'feature:viewer:toolbar:timeline'
  | 'feature:viewer:toolbar:wms'
  | 'feature:viewer:wms:layers:satellite'
  | 'feature:viewer:chips:share_viewer'
  | 'feature:viewer:chips:as_built'
  | 'feature:shared_viewer:context_menu'
  | 'feature:global:intercom:widget'
  | 'feature:global:intercom:help_center'
  | 'feature:file_manager:share_folder'
  | 'feature:file_manager:tags'
  | 'feature:file_manager:connect_folder';

// A list of features that supports Cerbos policy checks.
export const cerbosControlledFeatures: Set<CerbosFeature> = new Set<CerbosFeature>([
  'feature:viewer:toolbar:focus',
  'feature:viewer:toolbar:comment',
  'feature:viewer:toolbar:measurement',
  'feature:viewer:toolbar:measurement:advanced',
  'feature:viewer:toolbar:select',
  'feature:viewer:toolbar:translate',
  'feature:viewer:toolbar:rotate',
  'feature:viewer:toolbar:scale',
  'feature:viewer:toolbar:light',
  'feature:viewer:toolbar:volume_calculation',
  'feature:viewer:toolbar:design',
  'feature:viewer:toolbar:tiled_model_scene',
  'feature:viewer:toolbar:ortho_tile_scene',
  'feature:viewer:toolbar:point_cloud_scene',
  'feature:viewer:toolbar:profile_section',
  'feature:viewer:toolbar:compare_ortho_photos',
  'feature:viewer:toolbar:original_photos',
  'feature:viewer:toolbar:occlusion_culling',
  'feature:viewer:toolbar:reference_plane',
  'feature:viewer:toolbar:timeline',
  'feature:viewer:toolbar:intersection',
  'feature:viewer:toolbar:wms',
  'feature:viewer:wms:layers:satellite',
  'feature:viewer:chips:share_viewer',
  'feature:shared_viewer:context_menu',
  'feature:global:intercom:widget',
  'feature:global:intercom:help_center',

  'feature:file_manager:share_folder',
  'feature:file_manager:tags',
  'feature:file_manager:connect_folder',
]);
